import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  CloseIconSmall,
  GiftCardIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { BookingStatus } from "../../__generated__/BookingCredits_booking.graphql";
import { BookingPaymentGiftCard_SquareGiftCard$key } from "./__generated__/BookingPaymentGiftCard_SquareGiftCard.graphql";

export const BookingPaymentGiftCard = ({
  squareGiftCardRef,
  bookingStatus,
  onRemove,
}: {
  squareGiftCardRef: BookingPaymentGiftCard_SquareGiftCard$key | null;
  bookingStatus?: BookingStatus;
  onRemove: (giftCardId: string) => void;
}) => {
  const squareGiftCard = useFragment(
    BookingPaymentGiftCardFragmentString,
    squareGiftCardRef
  );
  const { currencySymbol } = useGetClubCurrency();
  return (
    <Box
      p={3}
      borderRadius="2"
      backgroundColor={"surface-primary"}
      borderWidth={4}
      borderColor={"surface-secondary"}
      gap={2}
      testID={`gift-card-details-${squareGiftCard?.ganLastFour ?? ""}`}
    >
      <HStack
        bg="surface-primary"
        width="100%"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box borderRadius="2" flexDirection="row" gap={2} alignItems="center">
          <Box
            bg="surface-secondary"
            borderRadius="2"
            height={26}
            width={40}
            justifyContent="center"
            alignItems="center"
          >
            <GiftCardIcon />
          </Box>
          <VStack>
            <Text>{t`Gift Card ending ${
              squareGiftCard?.ganLastFour ?? ""
            }`}</Text>
            <Text
              variant="mainTiny"
              color="text-secondary"
            >{t`Balance: ${currencySymbol}${ConvertCentsToDollars(
              squareGiftCard?.balance ?? 0
            )}`}</Text>
          </VStack>
        </Box>
        {bookingStatus === "DRAFT" ? (
          <Button
            accessibilityLabel={t`Remove Gift Card`}
            variant="danger"
            size="tiny"
            leftIcon={<CloseIconSmall />}
            onPress={() => onRemove(squareGiftCard?.id ?? "")}
          />
        ) : null}
      </HStack>
    </Box>
  );
};

export const BookingPaymentGiftCardFragmentString = graphql`
  fragment BookingPaymentGiftCard_SquareGiftCard on SquareGiftCard {
    id
    balance
    ganLastFour
  }
`;
